import {
    handleRehydrateAction,
    handleRemoveAction,
    handleSubmitAction
} from '../../../core/store/helpers/reducer-helper';
import * as fromFormActions from './form.actions';
import { Form } from './form.model';
import { updateFromApiReducer } from './update-from-api.reducer';

export interface State {
    ids: Array<string>;
    entities: {[id: string]: Form};
}

export const initialState: State = {
    ids: [],
    entities: {}
};

// tslint:disable-next-line:only-arrow-functions
export function reducer(state = initialState, action: fromFormActions.Actions): State {
    switch (action.type) {
        case fromFormActions.SUBMIT: {
            return handleSubmitAction(state, action);
        }
        case fromFormActions.REHYDRATE: {
            return handleRehydrateAction(state, action);
        }
        case fromFormActions.REMOVE: {
            return handleRemoveAction(state, action);
        }
        case fromFormActions.UPDATE_FROM_API: {
            return updateFromApiReducer(state, action);
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/form/form.reducer.ts